import styled from 'styled-components';
import { Box } from '@mui/material';

export const ServiceDistributionSection = styled(Box)`
.boxWrapper {
    border: 1px solid #1b4a83;
    background-color: #fff;
    border-radius: 0px 0px 5px 5px;
    border-top: 5px solid rgb(27, 74, 131);
    padding: 30px;
    .boxHeading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 28px;
        
        h6 {
            font-size: 20px;
            text-align: left;
            color: rgb(27, 74, 131);
            font-weight: 600;
            width: 45%;
        }
        .requestformLeft {
          display: flex;
          align-items: center;
          gap: 15px;
          width:90%;
          justify-content: space-evenly;
          .heading
            {
                text-align: left;
                width: 55%;
                font-size:14px;
            }
          span {
            font-size: 14px;
            color: #b4b4b4;
            text-decoration: underline;
            cursor: pointer;
          }
          button {
            border-radius: 5px;
            background-color: #FFFFFF;
            cursor: pointer;
            fontSize: 10px;
          }
          .disbaled
          {
            background-color: #9E9E9E;
            color:#1A1A1A;
            text-transform: capitalize;
          }
          .active
          {
            background-color: #1B4A83;
            text-transform: capitalize;
          }
          .uploadedFileName{
            background-color: #239155;
            text-transform: capitalize;
          }
        }
      }
    .distribution {
      margin-top: 30px;
      
      table {
        border-radius: 5px;
      border:1px solid rgb(27, 74, 131);
        padding: 30px;
        thead {
          background-color:#1B4A83;
          tr {
            th {
              color: #FFFFFF;
              font-weight: 600;
            }
          }
          .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
            opacity: 1;
            color: #fff;
        }
         .MuiTableSortLabel-icon {
            opacity: 1;
            color:white;
            font-size:20px;
        }
        }
        tbody {
          border: 1px solid #1b4a83;
          border-radius: 0px 0px 5px 5px;
          border-bottom: 2px solid #1b4a83;
          td {
            text-align: start;
          }
        }
      }
    }
  }
`;

export const PaginationBox = styled(Box)`

    display: flex;
    justify-content: space-between;
    align-items: center;

    h6{
        color: #1B4A83;
        font-weight: 600;
        padding-left:10px;

        span{
            font-size:14px;
            font-weight: 500;
            color: #000;
            padding-left: 6px;
            font-family: 'Noto Sans', sans-serif;
        }
    }
    button {
        margin: 10px 0;
        border-radius: 2px;
    
}
.paginationContainer{
    display: flex;
    justify-content: space-between;
    align-items: center;

    h6{
        color: #1B4A83;
        font-weight: 600;

        span{
            font-size:14px;
            font-weight: 500;
            color: #000;
            padding-left: 6px;
        }
    }
    button {
        margin: 10px 0;
        border-radius: 2px;
    
}
}
`;